import React from "react";
import WatchTimer from "../../WatchApi/WatchTimer";

function CopyRight() {
    const Copyrightstyle = {
        // position: "absolute",
        position: "fixed",
        // bottom: 0,
        minWidth: "100vh",
        // whiteSpace: "nowrap",
        // lineHeight: "40px",
        marjin:0,
        textAlign: 'center',
        background: 'white'
        
        

    }
    const date = new Date();
    const year = date.getFullYear();
    return (
        <footer style={Copyrightstyle} className="border-top footer text-muted text-center">
            <div>Copyright &copy; {year * 1} <em> Jcoup </em> all right reserved.
                <em style={{ float: 'right', marginRight: '10px', color: 'blue' }}><WatchTimer></WatchTimer></em>
            </div>
        </footer>
    );
}
export default CopyRight;
